import { createContext, useReducer, useMemo, useContext } from 'react';

const data = [
  {
    value: 'projects',
    label: 'My Projects'
  },
  // {
  //   value: 'collateral',
  //   label: 'Collateral Area'
  // },
  {
    value: 'validations',
    label: 'My Validations'
  }
];

type DataProp = {
  value: string;
  label: string;
};

type SummaryProp = {
  summary: string[];
};

type SummaryProps = SummaryProp & {
  data: DataProp[];
  setState: (summary: string[]) => void;
  handleSelectOne: (value: string) => void;
};

const initialState = {
  summary: ['projects', /* 'collateral', */ 'validations'],
  data,
  setState: () => {},
  handleSelectOne: () => {}
};

const SummaryContext = createContext<SummaryProps>(initialState);

SummaryContext.displayName = 'SummaryContext';

const summaryReducer = (s: SummaryProp, v: SummaryProp) => ({ ...s, ...v });

export const SummaryProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(summaryReducer, initialState);
  const { summary } = state;

  const setState = (strings: string[]) => dispatch({ summary: strings });

  const handleSelectOne = (value: string) => {
    const selectedIndex = summary.findIndex((element: string) => {
      return element === value;
    });
    let newItemsNames: string[] = [];

    if (selectedIndex === -1) {
      newItemsNames = newItemsNames.concat(summary, value);
    } else if (selectedIndex === 0) {
      newItemsNames = newItemsNames.concat(summary.slice(1));
    } else if (selectedIndex > 0) {
      newItemsNames = newItemsNames.concat(
        summary.slice(0, selectedIndex),
        summary.slice(selectedIndex + 1)
      );
    }
    setState(newItemsNames);
  };

  const value = useMemo(
    () => ({
      ...state,
      data,
      setState,
      handleSelectOne
    }),
    [state]
  );

  return (
    <SummaryContext.Provider value={value}>{children}</SummaryContext.Provider>
  );
};

export const useSummary = () => {
  const context = useContext(SummaryContext);
  if (context === undefined) {
    throw new Error('useSummary must be used within a SummaryProvider');
  }
  return context;
};
